import { PricesResponseV2 } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as ROA from "fp-ts/ReadonlyArray"
import * as SEP from "fp-ts/Separated"

export const availablePrices = (prices: PricesResponseV2["prices"]) => F.pipe(prices, ROA.separate, SEP.right)
